
export default function PartnershipBenefits() {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: 'Proven Growth Model',
      description: 'Join a rapidly expanding industry with 300% growth in luxury outdoor hospitality over the past 5 years'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Secured Investments',
      description: 'All partnerships backed by tangible real estate assets and comprehensive insurance coverage'
    },
    {
      icon: 'ri-global-line',
      title: 'Market Leadership',
      description: 'Partner with the leading glamping development company with proven track record across multiple markets'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainable Returns',
      description: 'Eco-friendly developments that attract conscious travelers and ensure long-term profitability'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Management',
      description: 'Professional property management, marketing, and operations handled by experienced hospitality team'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Multiple Revenue Streams',
      description: 'Income from bookings, events, corporate retreats, and property appreciation'
    }
  ];

  const marketData = [
    { metric: '$2.1B', label: 'Global Glamping Market Size', growth: '+12.5% annually' },
    { metric: '89%', label: 'Average Occupancy Rate', growth: 'Peak season' },
    { metric: '$285', label: 'Average Daily Rate', growth: '+15% year-over-year' },
    { metric: '24%', label: 'Average Annual ROI', growth: 'OED Properties' }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Why Partner with OED?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join a proven business model in the fastest-growing segment of the hospitality industry
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center p-6">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${benefit.icon} text-2xl text-emerald-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gray-50 rounded-2xl p-8">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">Market Performance</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {marketData.map((data, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">{data.metric}</div>
                <div className="text-gray-900 font-semibold mb-1">{data.label}</div>
                <div className="text-sm text-emerald-500">{data.growth}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
